import { type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "../i18n";
import { Icon } from "./Icon";

// Motivational top-header band: text on the left, the generated image framed as a panel on
// the right with a soft fade (so the image is well-cropped, not stretched/sliced full-bleed).
export function HeroBand({
  image, eyebrow, title, sub, ctaLabel, ctaTo, onCta, ctaIcon = "sparkle", children,
}: {
  image: string;
  eyebrow: string;
  title: ReactNode;
  sub: string;
  ctaLabel: string;
  ctaTo?: string;
  onCta?: () => void;
  ctaIcon?: string;
  children?: ReactNode;
}) {
  const nav = useNavigate();
  const tr = useT();
  return (
    <section className="herobanner">
      <div className="herobanner-in">
        <div className="eyebrow"><span className="dot" /> {tr(eyebrow)}</div>
        <h1 className="herobanner-title">{title}</h1>
        <p className="herobanner-sub">{tr(sub)}</p>
        <div className="row wrap" style={{ gap: 10 }}>
          <button className="btn primary" onClick={() => (onCta ? onCta() : ctaTo && nav(ctaTo))}><Icon name={ctaIcon} size={15} /> {tr(ctaLabel)}</button>
          {children}
        </div>
      </div>
      <div className="herobanner-art" style={{ backgroundImage: `url(${image})` }} aria-hidden="true" />
    </section>
  );
}
